import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import scopeImage from '../../../Assets/ResearchLabs/Common/AI Domains/RSGCRL-Domain-AI.png';

const { Paragraph, Title } = Typography;

const Scope = () => (
  <section className="scope-section">
    <div className="scope-section-inner">
      <Row gutter={[72, 40]} align="middle" justify="space-between">
        <Col xs={24} md={15}>
          <Title level={2} className="scope-title">Scope</Title>
          <Divider className="ncgsa-divider" />
          <Paragraph className="scope-description">
            The Remote Sensing, GIS and Climatic Research Lab (RSGCRL), University of the Punjab,
            Lahore shall promote and facilitate education, research activities and collaborations
            to study and develop GIS and Space Applications with particular emphasis on sustainable
            development in Pakistan, and cost-effective tools for developing world.
          </Paragraph>
          <Paragraph className="scope-description">
            The research and development activities of the lab will contribute towards sustainable
            development in Pakistan through
          </Paragraph>
          <Paragraph className="scope-description">
            (i) Developing a broader analytical base from ground and satellite data for an effective
            and informed decision making for professional institutions and policy makers, and
          </Paragraph>
          <Paragraph className="scope-description">
            (ii) Designing and developing efficient and cost-effective GIS and Space Applications
            for climate change analyses, and
          </Paragraph>
          <Paragraph className="scope-description">
            (iii) Building professional and academic capacity for adaptation/mitigation/prevention
            strategies to combat climate change, and
          </Paragraph>
          <Paragraph className="scope-description">
            (iv) Increasing research and development activities through collaborations with national
            and international professional organizations
          </Paragraph>
        </Col>
        <Col xs={24} md={8}>
          <div className="scope-image-wrap">
            <img
              src={scopeImage}
              alt="Remote sensing and GIS climate analysis"
              className="scope-image"
            />
          </div>
        </Col>
      </Row>
    </div>
  </section>
);

export default Scope;
